/**
 * Strip HTML tags from a string to get plain text
 * @param {string} html - HTML string
 * @returns {string} - Plain text without HTML tags
 */
export const stripHtmlTags = (html) => {
  if (!html) return '';
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
};

/**
 * Get a plain text preview of HTML content (first N characters)
 * @param {string} html - HTML string
 * @param {number} maxLength - Maximum length of preview
 * @returns {string} - Plain text preview
 */
export const getHtmlPreview = (html, maxLength = 150) => {
  const text = stripHtmlTags(html);
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

